import cx from 'classnames';
import { createPortal } from 'react-dom';
import OutsideClickHandler from 'react-outside-click-handler';

import Button from 'components/shared/Button';
import ReactSelect from 'components/shared/FormAdapters/FormDefault/ReactSelect';
import Icon from 'components/shared/Icon';
import TranslateIcon from 'components/shared/Icon/icons/TranslateIcon';
import i18n from 'i18n';

import { useLandingTranslater } from './functions';
import s from './index.module.css';
import { localeCollection } from './utils';

function LandingTranslater(props) {
  const { isLoading, handleSubmit, value, setValue, open, setOpen, handleReset, showResetButton, sortByAlphabet } =
    useLandingTranslater(props);

  return createPortal(
    <OutsideClickHandler onOutsideClick={() => setOpen(false)}>
      <div className={cx(s.wrapper, open && s.open)}>
        <div className={s.head} onClick={() => setOpen(true)}>
          <div className={s.iconWrapper}>
            <Icon component={TranslateIcon} />
          </div>
          <div className={s.help}>
            <span>
              {open
                ? i18n.t('proposal_content.translation_widget.select_language')
                : i18n.t('proposal_content.translation_widget.click_me')}
            </span>
          </div>
        </div>
        <div className={s.widget}>
          <div className={s.block}>
            <ReactSelect
              value={value}
              onChange={setValue}
              options={sortByAlphabet(localeCollection)}
              placeholder={i18n.t('proposal_content.translation_widget.select')}
            />
          </div>
          <div className={s.actions}>
            {showResetButton && (
              <Button
                type="default"
                htmlType="button"
                onClick={handleReset}
                disabled={isLoading}
                className={s.button}
                size="small"
              >
                {i18n.t('proposal_content.translation_widget.reset')}
              </Button>
            )}

            <Button
              htmlType="button"
              disabled={isLoading || !value}
              onClick={handleSubmit}
              className={s.button}
              size="small"
            >
              {isLoading ? 'Translating' : i18n.t('proposal_content.translation_widget.translate')}
            </Button>
          </div>
        </div>
      </div>
    </OutsideClickHandler>,
    document.body,
  );
}

export default LandingTranslater;
